import React, { useState, useEffect } from "react";
import "../../../styles/desktop/chamados.css";
import Acao from "./acao/acao";
import getChamadosByIdRegistro from "../../../API/server/getChamadosByIdRegistro";
import updateChamadoSolution from "../../../API/server/updateSolucaoChamado";

export default function Chamados({ evento, onClose, getData }) {
    const [showAcao, setShowAcao] = useState(false);
    const [chamadoDetalhes, setChamadoDetalhes] = useState(null); // Armazena os detalhes do chamado
    const [loading, setLoading] = useState(true); // Controle de loading
    const [solucao, setSolucao] = useState(""); // Estado para a solução selecionada

    useEffect(() => {
        const fetchChamado = async () => {
            try {
                const response = await getChamadosByIdRegistro(evento.id); // Busca o chamado pelo registroId
                setChamadoDetalhes(response);
            } catch (error) {
                console.error("Erro ao buscar detalhes do chamado:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchChamado();
    }, [evento.id]);

    const handleRealizarAcao = () => {
        setShowAcao(true); // Exibe o componente filho "Acao"
    };

    const setStatusMessage = () => {
        let statusLabel;

        if (chamadoDetalhes.chamado.solucao) {
            statusLabel = "Concluído";
        } else if (chamadoDetalhes.chamado.status === "aberto") {
            statusLabel = "Pendente";
        } else if (chamadoDetalhes.chamado.status === "em andamento") {
            statusLabel = "Solicitação enviada para o responsável";
        } else {
            statusLabel = "Concluído pendente";
        }
        return statusLabel;
    }

    const handleSalvarSolucao = async () => {
        if (solucao) {
            try {
                // Atualiza o status e salva a solução no backend
                const response = await updateChamadoSolution(chamadoDetalhes.chamado.id, solucao);

                if (response?.chamado) {
                    const atualizado = {
                        ...chamadoDetalhes,
                        chamado: {
                            ...response.chamado,
                            status: "Concluído",
                            solucao: response.chamado.solucao,
                        },
                    };
                    setChamadoDetalhes(atualizado);
                    getData();
                    alert("Solução salva com sucesso!");
                } else {
                    alert("Erro ao salvar a solução: " + response.error);
                }
            } catch (error) {
                console.error("Erro ao salvar solução:", error);
                alert("Erro ao salvar a solução.");
            }
        } else {
            alert("Por favor, selecione uma solução antes de salvar.");
        }
    };

    const renderBtnOptions = () => {
        console.log(chamadoDetalhes)
        if(chamadoDetalhes.chamado.solucao) {
            return (
                <button id="btnAcao-acao" className="btnChamados" onClick={onClose}>
                    Voltar
                </button>
            );
        } else if(chamadoDetalhes.chamado.status === "concluído") {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleSalvarSolucao}>
                        Finalizar Chamado
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
            </div>
            ) 
        } else if(chamadoDetalhes.chamado.status === "em andamento") {
            return (
                <div className="buttonOpçoesChamados">
                    <button id="btnAcao-acao" className="btnChamados" onClick={onClose}>
                        Voltar
                    </button>
                </div>
            ) 
        }
            else {
                return (
                    <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleRealizarAcao}>
                        Realizar ação
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
                )
            }
        }

    return (
        <div className="contentChamado">
            {loading ? (
                <p>Carregando detalhes do chamado...</p>
            ) : !showAcao ? (
                <>
                    <div className="headerChamado">
                        <div className="detalhesHeader">
                            <h3>Detalhes do Chamado</h3>
                        </div>
                        {chamadoDetalhes && (
                            <div className="detalhesEventosChamados">
                                {chamadoDetalhes.registros.map((registro, index) => (
                                    <div key={index} className="registroItem">
                                        <p><strong>Registro ID:</strong> {registro.id}</p>
                                        <p><strong>IP Controlador:</strong> {registro.ip}</p>
                                        <p><strong>Descrição:</strong> {registro.descricao}</p>
                                        <p><strong>Data:</strong> {registro.data}</p>
                                        <p><strong>Hora:</strong> {registro.hora}</p>
                                    </div>
                                ))}
                                <p>
                                    <strong>Status:</strong>{" "}
                                    {setStatusMessage()}
                                </p>
                                {chamadoDetalhes?.chamado.solucao && (
                                    <p>
                                        <strong>Solução:</strong> {chamadoDetalhes.chamado.solucao}
                                    </p>
                                )}
                                {chamadoDetalhes?.chamado.nome_user_final && (
                                    <p>
                                        <strong>Usuário que reportou o chamado:</strong> {chamadoDetalhes.chamado.nome_user_abertura || "chatbot"}
                                    </p>
                                )}
                                {chamadoDetalhes?.chamado.nome_user_final && (
                                    <p>
                                        <strong>Usuário que finalizou o chamado:</strong> {chamadoDetalhes.chamado.nome_user_final}
                                    </p>
                                )}
                                
                                {!chamadoDetalhes?.chamado.solucao &&
                                    chamadoDetalhes?.chamado.status === "concluído" && (
                                        <div className="solucaoSection">
                                            <label htmlFor="solucaoSelect">Como foi solucionado?</label>
                                            <select
                                                id="solucaoSelect"
                                                value={solucao}
                                                onChange={(e) => setSolucao(e.target.value)}
                                            >
                                                <option value="" disabled>Selecione...</option>
                                                <option value="Atendimento do Chamado">Atendimento do Chamado</option>
                                                <option value="Verificação Interna">Verificação Interna</option>
                                                <option value="Voltou Sozinho">Voltou Sozinho</option>
                                            </select>
                                        </div>
                                )}

                            </div>
                        )}
                    </div>
                    {renderBtnOptions()}
                </>
            ) : (
                <Acao 
                    onClose={() => setShowAcao(false)} 
                    updateRegistros={getData} // Passa a função para atualizar a lista de registros
                    fecharPai={onClose} // Função para fechar o componente pai Chamados
                    chamadoDetalhes={chamadoDetalhes} 
                />

            )}
        </div>
    );
}
